export default {"src":"/_next/static/media/electronics.39944f73.svg","height":121,"width":121};